import IndexStore from 'src/stores/index';
import type {ModuleSequenceNode} from 'src/stores/survey';
import type {
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Event'. Did you mean to use 'import Event from "src/api-parsers/events"' instead?
  Event,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Answer'. Did you mean to use 'import Answer from "src/api-parsers/events"' instead?
  Answer,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'SurveyResponse'. Did you mean to use 'import SurveyResponse from "src/api-parsers/events"' instead?
  SurveyResponse,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'ApiSurveyResponse'. Did you mean to use 'import ApiSurveyResponse from "src/api-parsers/events"' instead?
  ApiSurveyResponse,
} from 'src/api-parsers/events';
import type {Question, Branch, BranchId} from 'src/types/survey';


type EmailResponse = {
  module_value: string;
  module_id: string;
};

import exenv from 'exenv';
import find from 'lodash/find';
import flow from 'lodash/flow';
import includes from 'lodash/includes';
import size from 'lodash/size';
import map from 'lodash/map';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import uniqueId from 'lodash/uniqueId';
import invariant from 'invariant';
import sculpt from 'sculpt';

import logger from 'src/utils/logger';

import * as api from 'src/utils/api';
import {key, fetching} from 'src/utils/action';
import {contains} from 'src/utils/array';
import eventParsers from 'src/api-parsers/events';
import apiParsers from 'src/api-parsers/index';

import {
  recaptchaV3Verify,
  logRecaptchaSkipToSentry,
  getRecaptchaV3Token,
} from 'src/components/survey/utils';

// get miscellaneous client/request data - see #16446
function getRequestAndClientMetadata(store: IndexStore): {
  [key: string]: string | string[];
} {
  // @ts-expect-error - TS2339 - Property 'reduxStore' does not exist on type 'IndexStore'.
  const meta = store.reduxStore.getState().requestHeaders.meta;
  if (exenv.canUseDOM) {
    // who knows, maybe this is different than the values from the server req
    meta.clientUA = window.navigator.userAgent;
    meta.clientReferrer = document.referrer;
    meta.clientUrl = window.location.href;
  }
  return meta;
}

export function goForward(store: IndexStore, eventId: string): void {
  const survey = store.survey.byId(eventId);
  const progress = store.survey.progressById(eventId);
  const surveyResponse = store.surveyResponses.byEventId(eventId);
  const moduleSequence = getModuleSequence(store, survey, surveyResponse);

  if (survey) {
    store.survey.setModuleSequence(survey.id, moduleSequence);
    store.survey.goto(eventId, progress + 1);
    store.surveyResponses.setCurrentError(null);
  }
}

// needed: better name for going back one question
export function goBack(store: IndexStore, eventId: string): void {
  const survey = store.survey.byId(eventId);
  const progress = store.survey.progressById(eventId);
  const surveyResponse = store.surveyResponses.byEventId(eventId);
  const moduleSequence = getModuleSequence(store, survey, surveyResponse);

  if (survey) {
    store.survey.setModuleSequence(survey.id, moduleSequence);
    store.survey.goto(eventId, progress - 1);
    store.surveyResponses.setCurrentError(null);
  }
}

export function goto(store: IndexStore, eventId: string, position: number) {
  const survey = store.survey.byId(eventId);
  const surveyResponse = store.surveyResponses.byEventId(eventId);
  const moduleSequence = getModuleSequence(store, survey, surveyResponse);

  store.survey.setModuleSequence(survey.id, moduleSequence);
  store.survey.goto(eventId, position);
  store.surveyResponses.setCurrentError(null);
}

export function track(
  store: IndexStore,
  sentEventId: string,
  question: Question,
): Promise<void> {
  return api
    .post(store, `events/sent/${sentEventId}/modules/view`, {
      module_ids: [question.id],
    })
    .catch((error) => {
      logger.error('survey track error: ', error.stack || error);
    });
}

export function addSurveyResponseHandshake(
  store: IndexStore,
  sentEventId: string,
  token: string,
): Promise<void> {
  return api
    .put(store, `responses/sent/${sentEventId}/handshake`, {
      token,
    })
    .catch((error) => {
      logger.error(
        `unable to put handshake token ${token} for survey ${sentEventId}`,
        error.stack || error,
      );
    });
}

// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '{ (store: IndexStore, responseId: string, sentEventId: string, questionId: string, question: Question, value?: any, skipRecaptcha?: boolean | null | undefined): Promise<...>; KEY: (responseId: string, sentEventId: string | ... 1 more ... | undefined, questionId: string) => string; }'.
export const respond: {
  (
    store: IndexStore,
    responseId: string,
    sentEventId: string,
    questionId: string,
    question: Question,
    value?: any,
    skipRecaptcha?: boolean | null | undefined,
  ): Promise<void>;
  KEY: (
    responseId: string,
    sentEventId: string | null | undefined,
    questionId: string,
  ) => string;
} = flow(
  key(
    // @ts-expect-error - TS7006 - Parameter 'responseId' implicitly has an 'any' type. | TS7006 - Parameter 'sentEventId' implicitly has an 'any' type. | TS7006 - Parameter 'questionId' implicitly has an 'any' type.
    (responseId, sentEventId, questionId) =>
      `${questionId}_response_${responseId}`,
  ),
  fetching(),
)(
  (
    store: IndexStore,
    responseId: string,
    sentEventId: string,
    questionId: string,
    question: Question,
    value: any,
    skipRecaptcha?: boolean | null,
  ): Promise<void> => {
    const answer = createAnswer(question, value);

    if (!store.surveyResponses.validate(question, answer)) {
      return Promise.reject();
    }

    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'number'.
    store.surveyResponses.recordResponse(responseId, questionId, answer);
    const eventId = store.sentEvents.byId(sentEventId).eventId;
    const isPossibleBot = store.survey.getIsPossibleBot();
    const {responseModules} = store.surveyResponses.byEventId(eventId);
    const response = {
      id: responseId,
      authorId: '', // TODO(marcos): where should this be coming from?
      type: 'survey_response',
      eventId,
      responseModules,
      isPossibleBot,
    } as const;

    //update response modules to remove any orphaned branch modules.
    const survey = store.survey.byId(eventId);
    const moduleSequence = getModuleSequence(store, survey, response);
    // @ts-expect-error - TS2540 - Cannot assign to 'responseModules' because it is a read-only property.
    response.responseModules = responseModules.filter(
      // @ts-expect-error - TS7006 - Parameter 'module' implicitly has an 'any' type.
      (module) => map(moduleSequence, 'moduleId').indexOf(module.moduleId) > -1,
    );

    const apiResponse = eventParsers.normalize.surveyResponse(response);
    const meta = getRequestAndClientMetadata(store);
    return api
      .put(
        store,
        `responses/${responseId}`,
        {...apiResponse, meta},
        {
          id: sentEventId,
          nonce: uniqueId(`${Date.now()}_`),
        },
      )
      .then((response) => {
        response = eventParsers.parse.surveyResponse(response);
        store.surveyResponses.receiveResponse(response);
        store.survey.setModuleSequence(survey.id, moduleSequence);
        if (!skipRecaptcha) {
          recaptchaV3Verify(
            store,
            sentEventId,
            response.responseModules[response.responseModules.length - 1].id,
            'updating_response',
            meta,
          );
        }
      });
  },
);

// eslint-disable-next-line max-params
export function respondToPreview(
  store: IndexStore,
  responseId: string,
  eventId: string,
  questionId: string,
  question: Question,
  value: any,
): Promise<void> {
  const answer = createAnswer(question, value);
  if (!store.surveyResponses.validate(question, answer)) {
    return Promise.reject();
  }
  // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'number'.
  store.surveyResponses.recordResponse(responseId, questionId, answer);
  return Promise.resolve(store.surveyResponses.byEventId(eventId));
}

// TODO: rename createResponse?
export function createAnswer(question: Question, response: any): Answer {
  const {id, type} = question;
  const typeMappings = {
    rating_scale_survey_question: 'rating_scale_survey_answer',
    nps_survey_question: 'nps_survey_answer',
    multiple_choice_survey_question: 'multiple_choice_survey_answer',
    checkboxes_survey_question: 'checkboxes_survey_answer',
    text_survey_question: 'text_survey_answer',
    calendar_date_survey_question: 'calendar_date_survey_answer',
    // We will never create a response for these even though
    // they are valid module types, they aren't 'respondable' by the
    // client in any meaningful way beyond response_handshake_token
    message_survey_module: 'message_survey_module',

    // can't respond through UI, only on twilio callback on backend
    sms_message_survey_module: undefined,
  } as const;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"rating_scale_survey_question" | "nps_survey_question" | "multiple_choice_survey_question" | "checkboxes_survey_question" | "text_survey_question" | "message_survey_module" | "attribute_list_module" | "sms_message_survey_module" | "beefree_module"' can't be used to index type '{ readonly rating_scale_survey_question: "rating_scale_survey_answer"; readonly nps_survey_question: "nps_survey_answer"; readonly multiple_choice_survey_question: "multiple_choice_survey_answer"; ... 4 more ...; readonly sms_message_survey_module: undefined; }'.
  if (!typeMappings[type]) {
    throw new Error(`InvalidType: ${type} Question`);
  } else {
    const answer = {
      moduleId: id,
      moduleValue: response,
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"rating_scale_survey_question" | "nps_survey_question" | "multiple_choice_survey_question" | "checkboxes_survey_question" | "text_survey_question" | "message_survey_module" | "attribute_list_module" | "sms_message_survey_module" | "beefree_module"' can't be used to index type '{ readonly rating_scale_survey_question: "rating_scale_survey_answer"; readonly nps_survey_question: "nps_survey_answer"; readonly multiple_choice_survey_question: "multiple_choice_survey_answer"; ... 4 more ...; readonly sms_message_survey_module: undefined; }'.
      type: typeMappings[type],
    } as const;

    if (
      question.type === 'rating_scale_survey_question' ||
      question.type === 'nps_survey_question'
    ) {
      // @ts-expect-error - TS2540 - Cannot assign to 'moduleValue' because it is a read-only property.
      answer.moduleValue = parseInt(answer.moduleValue, 10);
      invariant(
        answer.moduleValue >= question.minRating &&
          answer.moduleValue <= question.maxRating,
        'InvalidResponse: Attempted to choose an invalid rating value.',
      );
    }

    if (question.type === 'multiple_choice_survey_question') {
      const responses = Array.isArray(response) ? response : [response];
      const choicesContainResponses = contains(
        question.choices.map((c) => c.value),
        responses,
      );

      invariant(
        choicesContainResponses,
        'InvalidResponse: Attempted to choose a value outside the list of choices.',
      );
    }

    return answer;
  }
}

export function createAnswerFromEmail(
  store: IndexStore,
  eventId: string,
  data: EmailResponse,
): Answer {
  const firstQuestion: Question | null | undefined =
    store.survey.firstQuestion(eventId);

  if (!firstQuestion) {
    throw 'Conflict: Could not find first survey question';
  }
  if (data.module_id !== firstQuestion.id) {
    throw 'Conflict: Response id does not match question id';
  }
  return createAnswer(firstQuestion, data.module_value);
}

export function getSentEvent(
  store: IndexStore,
  sent_event_id: string,
): Promise<void> {
  const promise = api
    .get(store, `events/sent/${sent_event_id}`)
    .then((response) => {
      const parsedResponse = eventParsers.parse.sentEvent(response);
      store.sentEvents.receiveSentEvent(parsedResponse);

      // TODO (rng) - IMPORTANT!!! We can remove this entire responder stuff because it's not really used in surveys
      // This will not exist in a MultiEntity event
      if (response.audience_member) {
        const parsedResponder = apiParsers.parse.audienceMember(
          response.audience_member,
        );
        store.responders.receiveResponder(parsedResponder);
      }

      const parsedEvent = eventParsers.parse.event(response.event);
      // TODO (kyle): we have some customers with surveys that are attached to `message` events.
      // rather than causing this page to crash, i'd prefer that we allow the survey to be complete,
      // and then figure out why a survey ever got attached to a message in the first place.
      /*
      if (
        !['beefree_email', 'survey', 'sms_survey'].includes(parsedEvent.type)
      ) {
        throw new Error(
          `Tried to import a non-survey ${parsedEvent.type} touchpoint into survey store. /workflow/${parsedEvent.workflowId}/event/${parsedEvent.id}`,
        );
      }
      */
      // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
      store.survey.receiveResponse(parsedEvent);
      const parsedBranches = eventParsers.parse.branches(response.event);
      if (size(parsedBranches) > 0) {
        store.branches.receiveBranches(parsedBranches);
      }
      store.survey.setModuleSequence(
        parsedEvent.id,
        getModuleSequence(store, parsedEvent),
      );
    })
    .catch((error) => {
      logger.error('survey getSentEvent error: ', error.stack || error);
    });

  // @ts-expect-error - TS2345 - Argument of type 'Promise<void>' is not assignable to parameter of type 'Promise<undefined>'.
  store.sentEvents.startFetching(promise);
  return promise;
}

export function getResponder(
  store: IndexStore,
  audienceMemberId: string,
): Promise<void> {
  const promise = api
    .get(store, `audience-members/${audienceMemberId}`)
    .then((response) => {
      const parsedResponder = apiParsers.parse.audienceMember(response);
      store.responders.receiveResponder(parsedResponder);
    })
    .catch((error) => {
      logger.error('survey getResponder error: ', error.stack || error);
    });

  // @ts-expect-error - TS2345 - Argument of type 'Promise<void>' is not assignable to parameter of type 'Promise<undefined>'.
  store.responders.startFetching(promise);
  return promise;
}

export function getBrandingSettings(
  store: IndexStore,
  id: string,
): Promise<void> {
  const surveyPromise = api
    .get(store, `events/${id}/branding_settings`)
    .then((response) => {
      const parsedResponse = apiParsers.parse.brandingSettings(response);
      store.survey.setBrandingSettings(id, parsedResponse);
    })
    .catch((error) => {
      logger.error('survey getBrandingSettings error: ', error.stack || error);
    });

  return surveyPromise;
}

export function getSurvey(store: IndexStore, id: string): Promise<void> {
  const surveyPromise = api
    .get(store, `events/${id}`)
    .then((response) => {
      const parsedEvent = eventParsers.parse.event(response);
      if (
        !includes(
          ['survey', 'message', 'sms_message', 'sms_survey'],
          parsedEvent.type,
        )
      ) {
        throw new Error(
          'tried to import a non-survey touchpoint into survey store',
        );
      }

      const parsedBranches = eventParsers.parse.branches(response);
      if (size(parsedBranches) > 0) {
        store.branches.receiveBranches(parsedBranches);
      }

      store.survey.receiveResponse(parsedEvent, parsedBranches);
      store.survey.setModuleSequence(
        parsedEvent.id,
        getModuleSequence(store, parsedEvent),
      );
    })
    .catch((error) => {
      logger.error('survey getSurvey error: ', error.stack || error);
    });

  // @ts-expect-error - TS2345 - Argument of type 'Promise<void>' is not assignable to parameter of type 'Promise<undefined>'.
  store.survey.startFetching(surveyPromise);
  return surveyPromise;
}

export function createResponseFromEmailAndSaveInBackup(
  store: IndexStore,
  sentId: string,
  initialResponse?: EmailResponse | null,
): Promise<SurveyResponse> {
  const meta = getRequestAndClientMetadata(store);
  const eventId = store.sentEvents.byId(sentId).eventId;

  let surveyResponse = apiEmptySurveyResponse;

  if (initialResponse) {
    try {
      const answer = createAnswerFromEmail(store, eventId, initialResponse);
      const apiAnswer = eventParsers.normalize.answer(answer);
      // @ts-expect-error - TS2349 - This expression is not callable.
      surveyResponse = sculpt(surveyResponse, {
        response_modules: {
          [0]: {$set: apiAnswer},
        },
      });
    } catch (error: any) {
      logger.warning('Initial response was invalid. Ignoring.');
      logRecaptchaSkipToSentry('Initial response was invalid.');
    }
  }

  const responsePromise = api
    .post(store, `responses/initial-response?id=${sentId}`, {
      ...surveyResponse,
      meta,
    })
    .then((response) => {
      // response is coming as null on success from backend
      let newResponse = {
        id: 'dummyEventResponseId',
        event_id: eventId,
        type: 'survey_response',
        ...surveyResponse,
      };
      newResponse = eventParsers.parse.surveyResponse(newResponse);
      store.surveyResponses.receiveResponse(newResponse);

      return newResponse;
    })
    .catch((error) => {
      logger.error(
        `survey creating empty backup response for ${sentId} failed in the event_response_backup table`,
      );
      logger.error(error.stack || error);
    });

  store.surveyResponses.startFetching(responsePromise);
  return responsePromise;
}

// Getting response and setting it to pre-populate in the UI in case of sms message survey
export function setResponse(store: IndexStore, sentId: string) {
  api
    .get(store, `responses/sent/${sentId}`)
    .then((response) => {
      response = eventParsers.parse.surveyResponse(response);
      store.surveyResponses.receiveResponse(response);
      store.survey.setIsSurveyAnswered(true);
    })
    .catch((error) => {
      logger.error(
        `[setResponse]: failed to get response for ${sentId}`,
        error,
      );
    });
}

export function getOrCreateResponse(
  store: IndexStore,
  sentId: string,
  initialResponse?: EmailResponse | null,
): Promise<SurveyResponse> {
  const meta = getRequestAndClientMetadata(store);
  const responsePromise = api
    .get(store, `responses/sent/${sentId}`)
    .then((response) => {
      // TODO(marcos) in this case, even if we have an initialresponse (say the person
      // clicks on an email again), we discard the initialresponse data.
      response = eventParsers.parse.surveyResponse(response);

      store.surveyResponses.receiveResponse(response);
      store.survey.setIsSurveyAnswered(true);
      if (response.responseModules.length > 0) {
        recaptchaV3Verify(
          store,
          sentId,
          response.responseModules[response.responseModules.length - 1].id,
          'creating_response',
          meta,
        );
      } else {
        logRecaptchaSkipToSentry('No responseModules were found');
      }
      return response;
    })
    .catch((error) => {
      logger.error('survey getOrCreateResponse error: ', error.stack || error);
      const eventId = store.sentEvents.byId(sentId).eventId;
      logger.log(
        `no responses found for sent touchpoint ${sentId}, creating one for ${eventId}`,
      );

      let surveyResponse = apiEmptySurveyResponse;
      surveyResponse = {
        ...surveyResponse,
        is_possible_bot: store.survey.getIsPossibleBot(),
      };

      if (initialResponse) {
        try {
          const answer = createAnswerFromEmail(store, eventId, initialResponse);
          const apiAnswer = eventParsers.normalize.answer(answer);
          // @ts-expect-error - TS2349 - This expression is not callable.
          surveyResponse = sculpt(surveyResponse, {
            response_modules: {
              [0]: {$set: apiAnswer},
            },
          });
        } catch (error: any) {
          logger.warning('Initial response was invalid. Ignoring.');
          logRecaptchaSkipToSentry('Initial response was invalid.');
        }
      }
      return api
        .post(store, 'responses', {...surveyResponse, meta}, {id: sentId})
        .then((response) => {
          response = eventParsers.parse.surveyResponse(response);
          // [ToDo] Is this is better place to run --> store.surveyResponses.removeDummyResponse()
          store.surveyResponses.receiveResponse(response);
          store.survey.setIsSurveyAnswered(true);
          // TODO (kyle): not sure this is necessary
          /*
          if (initialResponse) {
            store.survey.goto(response.eventId, 1);
          }
          */
          if (response.responseModules.length > 0) {
            recaptchaV3Verify(
              store,
              sentId,
              response.responseModules[response.responseModules.length - 1].id,
              'creating_response',
              meta,
            );
          } else {
            logRecaptchaSkipToSentry('No responseModules were found');
          }
          return response;
        })
        .catch((error) => {
          logger.error(`survey creating empty response for ${sentId} failed`);
          logger.error(error.stack || error);
        });
    });

  store.surveyResponses.startFetching(responsePromise);
  return responsePromise;
}

export async function checkForBot(
  store: IndexStore,
  sentId: string,
): Promise<void> {
  const recaptchaToken = await getRecaptchaV3Token(store, 'checking_bot');
  const meta = getRequestAndClientMetadata(store);
  try {
    const isPossibleBot = await api.post(store, 'bot-check', {
      re_captcha_token: recaptchaToken,
      sent_event_id: sentId,
      'user-agent': meta.clientUA,
      referrer: meta.clientReferrer,
    });
    store.survey.setIsPossibleBot(isPossibleBot);
  } catch (_: any) {
    store.survey.setIsPossibleBot(false);
  }
}
export async function resolveNonBotUser(
  store: IndexStore,
  responseId: string,
  sentId: string,
): Promise<void> {
  try {
    const {is_possible_bot: isPossibleBot} = await api.put(
      store,
      `responses/${responseId}/resolve-bot?id=${sentId}`,
    );
    store.survey.setIsPossibleBot(isPossibleBot);
  } catch (_: any) {
    store.survey.setIsPossibleBot(false);
  }
}
export function getNewPreviewReponse(
  store: IndexStore,
  eventId: string,
): SurveyResponse {
  return new Promise((resolve: (result: Promise<never>) => void) => {
    // @ts-expect-error - TS2349 - This expression is not callable.
    const newPreviewResponse = sculpt(emptySurveyResponse, {
      id: {
        $set: 'preview_' + eventId,
      },
      eventId: {
        $set: eventId,
      },
    });
    store.surveyResponses.receiveResponse(newPreviewResponse);
    return resolve(newPreviewResponse);
  });
}

export async function finish(
  store: IndexStore,
  eventId: string,
  sentEventId?: string,
) {
  if (sentEventId) {
    try {
      await api.post(store, `events/sent/${sentEventId}/complete`);
    } catch (err: any) {
      logger.error(`failed to record event completion for ${sentEventId}`);
    }
  }
}

export function sendSMSSurvey(
  store: IndexStore,
  eventId: string,
  workflowId: string,
  phoneNumber: string,
): Promise<void> {
  return api
    .post(store, `events/${eventId}/send/test-sms`, {
      phone_number: phoneNumber,
      workflow_id: workflowId,
    })
    .catch((error) => {
      logger.error('survey sendSMSSurvey error: ', error.stack || error);
      throw error;
    });
}

const apiEmptySurveyResponse: ApiSurveyResponse = {
  event_response_type: 'survey_response',
  response_modules: [],
  is_possible_bot: false,
};

const emptySurveyResponse: SurveyResponse = {
  id: '',
  type: 'survey_response',
  authorId: null,
  eventId: null,
  responseModules: [],
  is_possible_bot: false,
};

function constructModuleSequenceNode(
  moduleId: string | number,
  parentModuleId?: string | null,
  branchId?: string | null,
  branchModuleIndex?: number | null,
): ModuleSequenceNode {
  return {moduleId, parentModuleId, branchId, branchModuleIndex};
}

export function getModuleSequence(
  store: IndexStore,
  event: Event,
  surveyResponse?: SurveyResponse,
): ModuleSequenceNode[] {
  const moduleSequence: Array<never> = [];
  event.filteredQuestions.forEach((module: Question) => {
    moduleSequence.push(
      // @ts-expect-error - TS2345 - Argument of type 'ModuleSequenceNode' is not assignable to parameter of type 'never'.
      constructModuleSequenceNode(module.id, null, null, null),
    );

    // @ts-expect-error - TS2339 - Property 'branchIds' does not exist on type 'Question'.
    if (Array.isArray(module.branchIds) && surveyResponse) {
      //For each of the branches, the module sequence if the branch should be traversed
      // @ts-expect-error - TS2339 - Property 'branchIds' does not exist on type 'Question'.
      module.branchIds.forEach((branchId: BranchId) => {
        const branch = store.branches.getBranch(branchId.id);
        const responseModule =
          surveyResponse &&
          find(surveyResponse.responseModules, {moduleId: module.id});
        const responseValue = get(responseModule, 'moduleValue');

        if (
          branch &&
          responseModule &&
          shouldTraverseBranch(branch, responseValue)
        ) {
          // @ts-expect-error - TS2339 - Property 'questions' does not exist on type 'Branch'. | TS7006 - Parameter 'branchQuestion' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
          branch.questions.forEach((branchQuestion, index) => {
            moduleSequence.push(
              // @ts-expect-error - TS2345 - Argument of type 'ModuleSequenceNode' is not assignable to parameter of type 'never'.
              constructModuleSequenceNode(
                branchQuestion.id,
                module.id,
                branchId.id,
                index,
              ),
            );
          });
        }
      });
    }
  });
  return moduleSequence;
}

// TODO (kyle): this is not an action?
export function getNextRequiredQuestionIndex(
  eventId: string,
  store: IndexStore,
  moduleSequence: ModuleSequenceNode[] | null | undefined,
  progress: number,
): number {
  let {filteredQuestions: questions} = store.survey.byId(eventId);
  const currentResponse = store.surveyResponses.byEventId(eventId);

  if (moduleSequence && moduleSequence[progress]) {
    const currentModule = moduleSequence[progress];
    if (currentModule.parentModuleId) {
      // @ts-expect-error - TS2345 - Argument of type 'string | number | null | undefined' is not assignable to parameter of type 'string'. | TS2339 - Property 'questions' does not exist on type 'Branch'.
      questions = store.branches.getBranch(currentModule.branchId).questions;
    }
  }

  const nextRequiredQuestionIndex = questions
    // @ts-expect-error - TS7006 - Parameter 'question' implicitly has an 'any' type.
    .map((question) => {
      const hasBeenAnswered =
        currentResponse?.responseModules &&
        find(currentResponse.responseModules, {
          moduleId: question.id,
        });
      return get(question, 'required') && !hasBeenAnswered;
    })
    .findIndex(Boolean);

  return nextRequiredQuestionIndex !== -1
    ? nextRequiredQuestionIndex
    : questions.length + 1;
}

export function shouldTraverseBranch(
  branch: Branch,
  moduleValue?: any,
): boolean {
  // @ts-expect-error - TS2339 - Property 'questions' does not exist on type 'Branch'. | TS2339 - Property 'questions' does not exist on type 'Branch'.
  if (branch.questions !== undefined && size(branch.questions) < 1) {
    return false;
  }
  if (!isNil(moduleValue)) {
    //Only needs to work with module_branches
    if (branch && branch.branchType === 'module_branch') {
      // @ts-expect-error - TS2339 - Property 'responseIn' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'. | TS2339 - Property 'responseIn' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
      if (branch.responseIn && size(branch.responseIn) > 0) {
        // @ts-expect-error - TS2339 - Property 'responseIn' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
        if (branch.responseIn.indexOf(moduleValue) > -1) {
          return true;
        }
        // @ts-expect-error - TS2339 - Property 'responseGte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'. | TS2339 - Property 'responseLte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
      } else if (branch.responseGte && branch.responseLte) {
        return (
          // @ts-expect-error - TS2339 - Property 'responseGte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'. | TS2339 - Property 'responseLte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
          moduleValue >= branch.responseGte && moduleValue <= branch.responseLte
        );
        // @ts-expect-error - TS2339 - Property 'responseGte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'. | TS2339 - Property 'responseGte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
      } else if (branch.responseGte && moduleValue >= branch.responseGte) {
        return true;
        // @ts-expect-error - TS2339 - Property 'responseLte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'. | TS2339 - Property 'responseLte' does not exist on type '(BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { responseIn: string[]; }) | (BranchCommon & { branchType: "module_branch"; questions: Question[]; } & { ...; }) | (BranchCommon & ... 1 more ... & { ...; }) | (BranchCommon & ... 1 more ... & { ...; })'.
      } else if (branch.responseLte && moduleValue <= branch.responseLte) {
        return true;
      }
    }
  }
  return false;
}

export function setClientFetchDone(store: IndexStore) {
  store.survey.setClientFetchDone();
}
